/* eslint-disable */
import { getLocalStorage } from './storage';

const localStorage = getLocalStorage();

const getQueryParam = (name, url) => {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&#]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, " "));
};

const wait = (t = 0) =>
  new Promise((y) =>
    setTimeout(() =>
      y()
    , t)
  );

const token = () => {
  return localStorage.getItem('token');
};

const debounce = (func, wait, immediate) => {
  var timeout;
  return function() {
    var context = this,
      args = arguments;
    const later = function() {
      timeout = null;
      if (!immediate) {
        func.apply(context, args);
      }
    };
    const callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
};

const embedCode = () => {
  return getQueryParam('eId');
};

export default {
  getQueryParam,
  token,
  wait,
  debounce,
  embedCode
};
